import { Box, Divider } from '@factorialco/deprecated-design-system'

import { BreakdownWorkedTime } from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/BankOfHoursPanel/lib/breakdownWorkedTime'
import { useTimesheetData } from 'modules/attendance/lib/timesheetDataContext'
import { TimesheetFeatures } from 'modules/attendance/lib/timesheetFeatures'

import ComplementaryHours from './ComplementaryHours'
import ExtraHours from './ExtraHours'
import PaidBreaks from './PaidBreaks'
import RegularHours from './RegularHours'

interface AccordionProps {
  workedTimeBreakdown: BreakdownWorkedTime
}

const Accordion = ({ workedTimeBreakdown }: AccordionProps) => {
  const { breaksMinutes, regularMinues, extraHourMinutes, breaksContributions } =
    workedTimeBreakdown

  const { isPartTime, featureByName } = useTimesheetData()
  const hasComplementaryHours = TimesheetFeatures.COMPLEMENTARY_HOURS in featureByName
  const shouldShowComplementaryHours = hasComplementaryHours && isPartTime
  return (
    <Box gap="s8" paddingY="s24">
      <Box
        border={{
          all: {
            width: 's1',
            color: 'grey400',
            style: 'solid',
          },
        }}
        borderRadius={{
          all: 'abs008',
        }}
      >
        {regularMinues > 0 && <RegularHours regularMinues={regularMinues} />}

        {extraHourMinutes > 0 && (
          <>
            <Divider />
            {shouldShowComplementaryHours ? (
              <ComplementaryHours complementaryHourMinutes={extraHourMinutes} />
            ) : (
              <ExtraHours extraHourMinutes={extraHourMinutes} />
            )}
          </>
        )}

        {breaksMinutes > 0 && (
          <>
            <Divider />
            <PaidBreaks breaksMinutes={breaksMinutes} breaksContributions={breaksContributions} />
          </>
        )}
      </Box>
    </Box>
  )
}

export default Accordion
